import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { TitleStyled } from 'petco-ui/elements/text/title/Title.styled';

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      font-size: 1.635rem;
      color: ${theme.primary.main};
    `,
  }),
  pageTitle: ({ theme }) => ({
    styles: `
      font-size: 1.25rem;
      text-align: center;
      color: ${theme.primary.text};
    `,
  }),
  pageSecondTitle: ({ theme }) => ({
    styles: `
        color: ${theme.primary.main};
        font-size: 1.25rem;
        margin-bottom: 0.75rem;
        text-align: left;
    `,
  }),
  sectionTitle: ({ theme }) => ({
    styles: `
      color: ${theme.primary.text};
      font-size: 1.5625rem;
      height: 2.125rem;
      letter-spacing: 0.0156rem;
      line-height: 1.25rem;
      text-align: left;
    `,
  }),
  profileTitle: ({ theme }) => ({
    styles: `
      font-size: 1.625rem;
      text-align: center;
      color: ${theme.primary.main};
    `,
  }),
  messageTitle: ({ theme }) => ({
    styles: `
      font-size: 1.5625rem;
      font-weight: 700;
      text-align: center;
      color: ${theme.primary.text};
    `,
  }),
  inverted: ({ theme }) => ({
    styles: `
      color: ${theme.primary.contrastText} !important;
    `,
  }),
  capitalize: () => ({
    styles: `
      text-transform: capitalize
    `,
  }),
};
const Title = styled(TitleStyled).attrs({
  className: 'Title',
})`
  ${applyStyleModifiers(modifiers)};
`;

export default Title;
